var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import { number, arrayOf, string } from 'prop-types';
import styled, { css } from 'styled-components';
import activeDot from '../activeDot';
import Text from '../../Text';
var Dot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var stepper = _ref.theme.yoga.components.stepper;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    width: 15px;\n    height: 15px;\n\n    border-radius: ", "px;\n  "])), stepper.dot.radius);
});
var Label = styled(Text.Bold)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var stepper = _ref2.theme.yoga.components.stepper;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    width: 95px;\n\n    font-size: ", "px;\n\n    transform: translateX(-50%);\n  "])), stepper.label.font.size);
});
var DotWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var active = _ref3.active,
      stepper = _ref3.theme.yoga.components.stepper;
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    width: 15px;\n\n    text-align: center;\n\n    ", " {\n      position: absolute;\n      left: 50%;\n      top: 10px;\n\n      color: ", ";\n    }\n\n    ", " {\n      position: absolute;\n      top: -10px;\n\n      background-color: ", ";\n    }\n  "])), Label, active ? stepper.label.color.active : stepper.label.color.inactive, Dot, active ? stepper.dot.backgroundColor.active : stepper.dot.backgroundColor.inactive);
});
var Wrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n"])));

var Dots = function Dots(_ref4) {
  var activeStep = _ref4.activeStep,
      labels = _ref4.labels;
  return /*#__PURE__*/React.createElement(Wrapper, null, labels.map(function (label, index) {
    return /*#__PURE__*/React.createElement(DotWrapper, {
      active: activeDot(index, activeStep),
      key: label
    }, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Label, {
      as: "span"
    }, label));
  }));
};

Dots.propTypes = {
  activeStep: number,
  labels: arrayOf(string)
};
Dots.defaultProps = {
  activeStep: 0,
  labels: []
};
export default Dots;